import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Errors, LocalService, UserService, ProfileService } from '../../core';
import { compareValidator } from '../../shared';
import { CONSTANTS } from '../../config/constants';

@Component({
  selector: 'app-tax-info-w9',
  templateUrl: './tax-info-w9.component.html',
  styleUrls: ['./tax-info-w9.component.scss']
})
export class TaxInfoW9Component implements OnInit, AfterViewInit {

  validations = CONSTANTS.validationMessages.formW9;
  validationsForWben = CONSTANTS.validationMessages.wben;
  errors: Errors = { errors: {} };
  userData: any;
  taxForm!: FormGroup;
  wbenForm!: FormGroup;
  signedOnDate = new Date().toISOString();
  currentDate = new Date().toISOString();
  dateOfBirth = new Date().toISOString();
  signedOnString: any;
  signedOnWbenDate: any;
  states = CONSTANTS.americaStates;
  taxId: any;
  ssnFlag: Boolean = true;
  mailingAddressInfo: Boolean = false;
  benForm: Boolean = false;
  itinFlag: Boolean = true;
  maxDate = new Date();
  isDateChange: Boolean = false;
  tabData: any;
  pageno: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    // this.checkTokenExpiry();
    this.getAllRoles();
    this.userData = LocalService.get('userProfile');
    this.taxForm = this.fb.group({
      'firstName': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'middleName': ['', [Validators.pattern(CONSTANTS.regex.alpha)]],
      'lastName': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'businessName': ['', [Validators.pattern(CONSTANTS.regex.alpha)]],
      'exemptPayeeCode': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'fatcaReportingCode': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'address': ['', [Validators.required, Validators.maxLength(200)]],
      'city': ['', [Validators.required, Validators.maxLength(50), Validators.pattern(CONSTANTS.regex.alpha)]],
      'state': ['', [Validators.required]],
      'zipCode': ['', [Validators.required, Validators.maxLength(5), Validators.pattern(CONSTANTS.regex.numeric)]],
      'requestorDetails': [''],
      'accountNumbers': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'ssn': [''],
      'confirmSsn': [''],
      'ein': [''],
      'confirmEin': [''],
      'signature': ['', [Validators.required, Validators.maxLength(100), Validators.pattern(CONSTANTS.regex.alpha)]],
      'signedOn': ['']
    });
    this.wbenForm = this.fb.group({
      'name': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'countryOfCitizenship': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'address': ['', [Validators.required, Validators.maxLength(200)]],
      'city': ['', [Validators.required, Validators.maxLength(50), Validators.pattern(CONSTANTS.regex.alpha)]],
      'state': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'zipCode': ['', [Validators.required, Validators.maxLength(5), Validators.pattern(CONSTANTS.regex.numeric)]],
      'country': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'mailingAddress': [''],
      'mailingCity': [''],
      'mailingState': [''],
      'mailingZipCode': [''],
      'mailingCountry': [''],
      'ssn': [''],
      'itin': [''],
      'foreignTaxIdentificationNumber': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'referenceNumbers': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'dateOfBirth': ['', [Validators.required]],
      'taxTreatyCountry': ['', [Validators.pattern(CONSTANTS.regex.alpha)]],
      'treatyParagraph': [''],
      'claimPercentageRate': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'typeOfIncome': [''],
      'additionalConditions': [''],
      'signature': ['', [Validators.required, Validators.maxLength(100), Validators.pattern(CONSTANTS.regex.alpha)]],
      'nameOfSigner': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'capacityInWhichActing': [''],
      'signedOn': ['']
    });
    if ('taxInfo' in this.userData && this.userData.taxInfo) {
      if ('taxInfoW9' in this.userData.taxInfo && this.userData.taxInfo.taxInfoW9) {
        this.taxForm.patchValue(this.userData.taxInfo.taxInfoW9, { onlySelf: true });
        this.taxId = this.userData.taxInfo.id;

        if (this.userData.taxInfo.taxInfoW9.ssn) {
          const ssn = this.userData.taxInfo.taxInfoW9.ssn;
          const newSsn = ssn.substring(0, 3) + '-' + ssn.substring(3, 5) + '-' + ssn.substring(5, 10);
          this.taxForm.patchValue({ ssn: newSsn });
          this.taxForm.patchValue({ confirmSsn: newSsn });
        } else {
          const ein = this.userData.taxInfo.taxInfoW9.ein;
          const newEin = ein.substring(0, 2) + '-' + ein.substring(2, 10);
          this.taxForm.patchValue({ ein: newEin });
          this.taxForm.patchValue({ confirmEin: newEin });
          this.ssnFlag = false;
        }
        this.toggleValidationSsnEin(this.ssnFlag);
        if (this.userData.taxInfo.taxInfoW9.signedOn) {
          this.signedOnDate = this.userData.taxInfo.taxInfoW9.signedOn;
          this.taxForm.patchValue({ signedOn: this.signedOnDate });
          this.signedOnString = this.signedOnDate.split('T')[0];
        }
      } else {
        this.taxForm.patchValue({ signedOn: this.signedOnDate });
        this.signedOnString = this.signedOnDate.split('T')[0];
      }
    } else {
      this.taxForm.patchValue({ signedOn: this.signedOnDate });
      this.signedOnString = this.signedOnDate.split('T')[0];
    }
    this.toggleValidationSsnEin(this.ssnFlag);
    this.toggleValidationSsnItin(this.itinFlag);
  }

  // Render to W8-BEN form
  renderToWben() {
    this.benForm = true;
    if ('taxInfo' in this.userData && this.userData.taxInfo) {
      if ('taxInfoW8BEN' in this.userData.taxInfo && this.userData.taxInfo.taxInfoW8BEN) {
        this.wbenForm.patchValue(this.userData.taxInfo.taxInfoW8BEN, { onlySelf: true });
        this.taxId = this.userData.taxInfo.id;
        if (this.userData.taxInfo.taxInfoW8BEN.ssn) {
          const ssn = this.userData.taxInfo.taxInfoW8BEN.ssn;
          const newSsn = ssn.substring(0, 3) + '-' + ssn.substring(3, 5) + '-' + ssn.substring(5, 10);
          this.wbenForm.patchValue({ ssn: newSsn });
        }
        if (this.userData.taxInfo.taxInfoW8BEN.itin) {
          const itin = this.userData.taxInfo.taxInfoW8BEN.itin;
          const newItin = itin.substring(0, 3) + '-' + itin.substring(3, 5) + '-' + itin.substring(5, 10);
          this.wbenForm.patchValue({ itin: newItin });
          this.itinFlag = false;
        }
        this.toggleValidationSsnItin(this.itinFlag);
        if (this.userData.taxInfo.taxInfoW8BEN.signedOn) {
          this.currentDate = this.userData.taxInfo.taxInfoW8BEN.signedOn;
          this.wbenForm.patchValue({ signedOn: this.currentDate });
          this.signedOnWbenDate = this.currentDate.split('T')[0];
        }
        if (this.userData.taxInfo.taxInfoW8BEN.dateOfBirth) {
          this.dateOfBirth = this.userData.taxInfo.taxInfoW8BEN.dateOfBirth;
          this.wbenForm.patchValue({ dateOfBirth: this.dateOfBirth.split('T')[0] });
        }
      } else {
        this.wbenForm.patchValue({ signedOn: this.currentDate });
        this.signedOnWbenDate = this.currentDate.split('T')[0];
      }
      if (this.userData.taxInfo.taxInfoW8BEN.mailingAddress) {
        this.changeMailingAddress();
      }
      this.mailingToggle();
    } else {
      this.wbenForm.patchValue({ signedOn: this.currentDate });
      this.signedOnWbenDate = this.currentDate.split('T')[0];
    }
  }

   // Reset field value after switching the SSN/EIN toggle
  changeSsnFlag(ssnFlag: any) {
    this.ssnFlag = ssnFlag;
    if (ssnFlag) {
      this.taxForm.controls['ssn'].reset();
      this.taxForm.controls['confirmSsn'].reset();
    } else {
      this.taxForm.controls['ein'].reset();
      this.taxForm.controls['confirmEin'].reset();
    }
    this.toggleValidationSsnEin(ssnFlag);
  }

  // Reset field value after switching the Mailing toggle
  changeMailingAddress() {
    this.mailingAddressInfo = !this.mailingAddressInfo;
    if (!this.mailingAddressInfo) {
      this.wbenForm.controls['mailingAddress'].reset();
      this.wbenForm.controls['mailingCity'].reset();
      this.wbenForm.controls['mailingState'].reset();
      this.wbenForm.controls['mailingZipCode'].reset();
      this.wbenForm.controls['mailingCountry'].reset();
    }
    this.mailingToggle();
  }

  // Reset field value after switching the SSN/ITIN toggle
  changeItinFlag(itinFlag: any) {
    this.itinFlag = itinFlag;
    if (!itinFlag) {
      this.wbenForm.controls['ssn'].reset();
    } else {
      this.wbenForm.controls['itin'].reset();
    }
    this.toggleValidationSsnItin(itinFlag);
  }

   // Validation handle while switching the toggle for Mailing information
  mailingToggle() {
    if (this.mailingAddressInfo) {
      this.wbenForm.get('mailingAddress')!.setValidators([
        Validators.required,
        Validators.maxLength(200)
      ]);
      this.wbenForm.get('mailingCity')!.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.regex.alpha),
        Validators.maxLength(50)
      ]);
      this.wbenForm.get('mailingState')!.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.regex.alpha)
      ]);
      this.wbenForm.get('mailingZipCode')!.setValidators([
        Validators.required, Validators.maxLength(5),
        Validators.pattern(CONSTANTS.regex.numeric)
      ]);
      this.wbenForm.get('mailingCountry')!.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.regex.alpha)
      ]);
    } else {
      this.wbenForm.get('mailingAddress')!.setValidators(null);
      this.wbenForm.get('mailingAddress')!.setErrors(null);
      this.wbenForm.get('mailingCity')!.setValidators(null);
      this.wbenForm.get('mailingCity')!.setErrors(null);
      this.wbenForm.get('mailingState')!.setValidators(null);
      this.wbenForm.get('mailingState')!.setErrors(null);
      this.wbenForm.get('mailingZipCode')!.setValidators(null);
      this.wbenForm.get('mailingZipCode')!.setErrors(null);
      this.wbenForm.get('mailingCountry')!.setValidators(null);
      this.wbenForm.get('mailingCountry')!.setErrors(null);
    }
    this.wbenForm.updateValueAndValidity();
  }

  // Validation handle while switching the toggle for SSN/ITIN
  toggleValidationSsnItin(itinFlag: any) {
    if (itinFlag) {
      this.wbenForm.get('ssn')!.setValidators([
        Validators.pattern(CONSTANTS.regex.ssn)
      ]);
      this.wbenForm.get('itin')!.setValidators(null);
      this.wbenForm.get('itin')!.setErrors(null);
    } else {
      this.wbenForm.get('ssn')!.setValidators(null);
      this.wbenForm.get('ssn')!.setErrors(null);
      this.wbenForm.get('itin')!.setValidators([
        Validators.pattern(CONSTANTS.regex.itin)
      ]);
    }
    this.wbenForm.updateValueAndValidity();
  }

  // Validation handle while switching the toggle for SSN/ITIN
  toggleValidationSsnEin(ssnFlag: any) {
    if (ssnFlag) {
      this.taxForm.get('ssn')!.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.regex.ssn)
      ]);
      this.taxForm.get('confirmSsn')!.setValidators([
        Validators.required,
        compareValidator('ssn')
      ]);
      this.taxForm.get('ein')!.setValidators(null);
      this.taxForm.get('confirmEin')!.setValidators(null);
      this.taxForm.get('ein')!.setErrors(null);
      this.taxForm.get('confirmEin')!.setErrors(null);
    } else {
      this.taxForm.get('ssn')!.setValidators(null);
      this.taxForm.get('confirmSsn')!.setValidators(null);
      this.taxForm.get('ssn')!.setErrors(null);
      this.taxForm.get('confirmSsn')!.setErrors(null);
      this.taxForm.get('ein')!.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.regex.ein)
      ]);
      this.taxForm.get('confirmEin')!.setValidators([
        Validators.required,
        compareValidator('ein')
      ]);
    }
    this.taxForm.updateValueAndValidity();
  }

  // Get list of all roles for users
  getAllRoles() {
    this.profileService.getAllRoles().subscribe((_data: any) => {
    }, (err: any) => {
      this.errors = err;
    });
  }

  // checkTokenExpiry() {
  //   this.userService.checkTokenExpiry().subscribe((data) => {
  //     console.log(data);
  //   }, err => {
  //     this.errors = err;
  //   });
  // }

  // Update W9/W8-BEN form information
  updateTaxInfo() {
    const userData = LocalService.get('userProfile');
    if (!this.benForm) {
      if (this.ssnFlag && this.taxForm.value.ssn) {
        const ssn = this.taxForm.get('ssn')!.value.replace(/-/g, '');
        this.taxForm.patchValue({ ssn: ssn });
        this.taxForm.patchValue({ ein: null });
      } else if (!this.ssnFlag && this.taxForm.value.ein) {
        const ein = this.taxForm.get('ein')!.value.replace(/-/g, '');
        this.taxForm.patchValue({ ein: ein });
        this.taxForm.patchValue({ ssn: null });
      }
      const taxObj = {
        id: this.taxId ? this.taxId : null,
        type: 'W9',
        taxInfoW9: this.taxForm.value,
      };
      userData.taxInfo = taxObj;
      delete userData.taxInfo.taxInfoW9.confirmSsn;
      delete userData.taxInfo.taxInfoW9.confirmEin;
    } else {
      if (this.itinFlag && this.wbenForm.value.ssn) {
        const ssn = this.wbenForm.get('ssn')!.value.replace(/-/g, '');
        this.wbenForm.patchValue({ ssn: ssn });
        this.wbenForm.patchValue({ itin: null });
      } else if (!this.itinFlag && this.wbenForm.value.itin) {
        const itin = this.wbenForm.get('itin')!.value.replace(/-/g, '');
        this.wbenForm.patchValue({ itin: itin });
        this.wbenForm.patchValue({ ssn: null });
      }
      const taxWBenObj = {
        id: this.taxId ? this.taxId : null,
        type: 'W8BEN',
        taxInfoW8BEN: this.wbenForm.value,
      };
      userData.taxInfo = taxWBenObj;
      if (userData.taxInfo.taxInfoW8BEN.dateOfBirth) {
        userData.taxInfo.taxInfoW8BEN.dateOfBirth = this.addDate(userData.taxInfo.taxInfoW8BEN.dateOfBirth);
      }
    }
    LocalService.set('userProfile', userData);
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  // Change value of flag on date change
  onDateChange() {
    this.isDateChange = true;
  }

  // Add date for user
  addDate(date: any) {
    if (this.isDateChange) {
      const birthDate = new Date(date);
      birthDate.setDate(birthDate.getDate() + 1);
      return birthDate.toISOString();
    }
    this.isDateChange = false;
    return date;
  }

  // Set hyphen for SIN
  setHyphen(val: any) {
    return `${val}-`;
  }

  // For checking type of a value
  checkType(value: any) {
    if (typeof (value) === 'number') {
      return true;
    }
    return false;
  }

  // Set SSN format
  setSSN(event: any, formValue: any) {
    if (event.key.length === 1) {
      const val = this.taxForm.value[formValue];
      const values = val.split('-');
      if (values.length === 1 && values[0].length === 3) {
        this.taxForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 2 && values[1].length === 2) {
        this.taxForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 3 && values[2].length === 4) {
        this.taxForm.patchValue({
          [formValue]: val
        });
      }
    }
  }

  // Set EIN format
  setEin(event: any, formValue: any) {
    if (event.key.length === 1) {
      const val = this.taxForm.value[formValue];
      const values = val.split('-');
      if (values.length === 1 && values[0].length === 2) {
        this.taxForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 2 && values[1].length === 7) {
        this.taxForm.patchValue({
          [formValue]: val
        });
      }
    }
  }

  // Set ITIN format
  setItin(event: any, formValue: any) {
    if (event.key.length === 1) {
      const val = this.wbenForm.value[formValue];
      const values = val.split('-');
      if (values.length === 1 && values[0].length === 3) {
        this.wbenForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 2 && values[1].length === 2) {
        this.wbenForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 3 && values[2].length === 4) {
        this.wbenForm.patchValue({
          [formValue]: val
        });
      }
    }
  }

  // For closing the datepicker
  closePicker(picker: any) {
    picker.open();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  openData(value: any, pageno: any) {
    this.pageno = pageno;
    this.tabData = value;
    if (this.tabData === 'sneak') {
      window.open('assets/images/pdf/General%20Instructions-converted.pdf#page=' + pageno, '_blank');
    }
  }

}
